module.exports = __webpack_public_path__ + "img/occidental-hotel-5.5a5a09e4.jpg";